import type { ReactNode } from 'react';

import { Skeleton } from '../../ui/skeleton';
import { st } from './messages';

export function LoadingState(props: { label?: string; lines?: number }): ReactNode {
  const lines = props.lines ?? 3;
  return (
    <div className="flex flex-col gap-3" role="status" aria-live="polite">
      <span className="sr-only">{props.label ?? st('loading')}</span>
      {Array.from({ length: lines }, (_, index) => (
        <Skeleton key={index} aria-hidden className="h-4 w-full last:w-2/3" />
      ))}
    </div>
  );
}
